export default [
  {
    name: 'OvertimeCompensation',
    path: '/overtime-compensation/index',
    component: () =>
      import(
        /* webpackChunkName: "OrderCancelReason" */ '@/views/overtime-compensation/index'
      ),
    meta: { title: '超时赔规则说明' },
  },
];
